import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ServerUrlService } from './server-url.service';

@Injectable({
  providedIn: 'root'
})
export class PlanosService {

  constructor(
    private http: HttpClient,
    private serverUrlService: ServerUrlService
  ) { }

  consultaPlanos() {
    return this.http.get(`${this.serverUrlService.getUrl()}/planos`);
  }
}
